var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostaicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2879_8073)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.225 16.1271C1.67868 14.1024 2.79395 12.2946 4.38815 10.9997C5.98235 9.70493 7.96098 8.99986 10 9H64C66.039 8.99986 68.0177 9.70493 69.6118 10.9997C71.206 12.2946 72.3213 14.1024 72.775 16.1271L37 38.3975L1.225 16.1271ZM1 21.3612V53.9212L27.1135 37.6137L1 21.3612ZM31.4245 40.3042L1.8595 58.7612C2.58997 60.3301 3.74287 61.6553 5.18402 62.5827C6.62516 63.5102 8.29529 64.0017 10 64H64C65.7044 64.0004 67.3739 63.5078 68.8143 62.5796C70.2546 61.6513 71.4065 60.3256 72.136 58.7567L42.571 40.2996L37 43.7692L31.4245 40.2996V40.3042ZM46.8865 37.6183L73 53.9212V21.3612L46.8865 37.6137V37.6183Z",
    fill: "#23A6F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2879_8073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostaicon);
export default __webpack_public_path__ + "static/media/postaicon.a8faf34d5d740d33a743ebb66c706fa2.svg";
export { ForwardRef as ReactComponent };